import Contracts from '@/components/contract/contract-list';
import ContractUpdate from '@/components/contract/contract-update';
const routes = [
    {
        path: '/contracts',
        name: 'contracts',
        component: Contracts,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                { text: 'Service contracts' }
            ],
			requiresAuth: true
        }
	},
	{
        path: '/contracts/:id/update',
        name: 'contractupdate',
        component: ContractUpdate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                {
                    text: 'Service Contracts',
                    href: 'javascript:history.back()',
                },
                { text: 'Edit' }
            ],
			requiresAuth: true
        }
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/contract/routes/index.js